<div *ngIf="mappedChartDatasetsReady">

    <div #canvasContainer class="canvas-container">

        <canvas baseChart
                [datasets]="mappedChartDatasets"
                [labels]="mappedChartAxisLabels"
                [legend]="chartLegend"
                [options]="chartOptions"
                [type]="chartType">
        </canvas>
    </div>
</div>
